// Packages
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useHistory, useParams } from "react-router-dom";
// Material ui
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import Popover from "@material-ui/core/Popover";
// Assets
import blankProfile from "../images/blank-profile.png";
// Styles
import "../../superAdmin/superAdmin.css";
// Views
import SchoolAdminDashboard from "../schoolAdminDashboard";
import { getFromLocalStorage } from "../../../utils/webStorage";
import { formatPhoneNumber } from "../../../utils";
import SchoolStatus from "../SchoolAdminPages/SchoolStatus/SchoolStatus";
import { ContentLayoutSpinner } from "../../spinner/ContentLayoutSpinner";
import ContentLayoutDetailsHeader from "../../../Common/ContentLayoutDetailsHeader";
import { AiFillSetting } from "react-icons/ai";
import { MdModeEdit } from "react-icons/md";
import { useSelector } from "react-redux";
import {
  getAthleteData,
  resetAthleteData,
} from "../../../Redux/Actions/AthleteActions";
import { useDispatch } from "react-redux";
import RestoreIcon from "@mui/icons-material/Restore";
import DeleteIcon from "@mui/icons-material/Delete";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { openConfirmationPopup } from "../../../Redux/Actions/PopupActions";
import SettingsPopup from "../../../Common/SettingsPopup";
import { resetGroupData } from "../../../Redux/Actions/GroupActions";

function AtheletDetails() {
  const [anchorEl, setAnchorEl] = useState(null);
  const adminRole = getFromLocalStorage("loginRole");
  const assignedRights = JSON.parse(
    getFromLocalStorage("assignedRights") || []
  ).map((item) => item?.displayName);
  const history = useHistory();
  const params = useParams();
  const athleteData = useSelector((state) => state?.AthleteData);
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const dispatch = useDispatch();

  const athleteone = document.getElementById("Athlete");
  if (athleteone) {
    athleteone.classList.add("btnActive");
  }

  useEffect(() => {
    getAthleteData(dispatch, { id: params?.athleteId });
    return () => {
      resetAthleteData(dispatch);
      resetGroupData(dispatch);
    };
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleDelete = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure You Want To Delete This Athlete?",
        btnColor: "red",
        btnText: "Yes",
        id: params?.athleteId,
        type: "Athlete Delete",
      },
    });
  };

  const handleReset = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure You Want To Reset The Password?",
        btnColor: "green",
        btnText: "Yes",
        email: athleteData?.athleteData?.email,
        type: "Reset Password",
      },
    });
  };

  const handleActivateInactivateTeamAdmin = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: `Are You Sure You Want To ${
          athleteData?.athleteData?.user?.active ? "Deactivate" : "Activate"
        } This Athlete?`,
        btnColor: "red",
        btnText: "Yes",
        id: athleteData?.athleteData?.id,
        status: !athleteData?.athleteData?.user?.active,
        type: "Athlete Activate / Deactivate",
      },
    });
  };

  const settingList = () => {
    let menuList = [];
    switch (true) {
      case athleteData?.athleteData?.user?.deleted === true:
        menuList = [
          {
            id: 1,
            name: "Recover Athlete",
            icon: <RestoreIcon className="manage-section-iconss" />,
            handleSubmit:
              athleteData?.athleteData?.user?.isFirstTime === false
                ? handleActivateInactivateTeamAdmin
                : handleReset,
          },
        ];
        break;

      case athleteData?.athleteData?.user?.active === true:
        menuList = [
          {
            id: 1,
            name: "Delete Athlete",
            icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
            handleSubmit: handleDelete,
          },
          {
            id: 2,
            name: "Reset Password",
            icon: <VpnKeyIcon className="manage-section-iconss" />,
            handleSubmit: handleReset,
          },
          {
            id: 3,
            name: athleteData?.athleteData?.user?.active
              ? "Deactivate Athlete"
              : "Activate Athlete",
            icon: athleteData?.athleteData?.user?.active ? (
              <DoDisturbOnIcon className="manage-section-iconss" />
            ) : (
              <CheckCircleIcon className="manage-section-iconss" />
            ),
            handleSubmit: handleActivateInactivateTeamAdmin,
          },
        ];
        break;

      case athleteData?.athleteData?.user?.isFirstTime === false &&
        athleteData?.athleteData?.user?.active === false:
        menuList = [
          {
            id: 1,
            name: "Delete Athlete",
            icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
            handleSubmit: handleDelete,
          },
          {
            id: 2,
            name: "Reset Password",
            icon: <VpnKeyIcon className="manage-section-iconss" />,
            handleSubmit: handleReset,
          },
          {
            id: 3,
            name: athleteData?.athleteData?.user?.active
              ? "Deactivate Athlete"
              : "Activate Athlete",
            icon: athleteData?.athleteData?.user?.active ? (
              <DoDisturbOnIcon className="manage-section-iconss" />
            ) : (
              <CheckCircleIcon className="manage-section-iconss" />
            ),
            handleSubmit: handleActivateInactivateTeamAdmin,
          },
        ];
        break;

      case athleteData?.athleteData?.user?.active === false:
        menuList = [
          {
            id: 1,
            name: "Delete Athlete",
            icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
            handleSubmit: handleDelete,
          },
          {
            id: 2,
            name: "Reset Password",
            icon: <VpnKeyIcon className="manage-section-iconss" />,
            handleSubmit: handleReset,
          },
        ];
        break;
      default:
        break;
    }
    return menuList;
  };

  const headerIcons = [
    {
      id: 1,
      icon: <MdModeEdit className="header-icon" />,
      handleClick: () =>
        history.push(`/editathlete/${athleteData?.athleteData?.id}`),
    },
    {
      id: 2,
      icon: <AiFillSetting className="header-icon" />,
      handleClick: handleClick,
    },
  ];

  return (
    <div>
      <div
        // className="content-layout add-sectionn p-0 position-relative"
        className={
          isDrawerOpen
            ? "content-layout add-sectionn p-0 position-relative"
            : "toggle-content-layout add-sectionn p-0 position-relative"
        }
      >
        <SchoolAdminDashboard />
        <ContentLayoutSpinner animate={athleteData?.loading?.pageLoading} />

        <ContentLayoutDetailsHeader
          label="Athlete"
          name={
            athleteData?.athleteData?.firstName ||
            athleteData?.athleteData?.lastName
              ? `${athleteData?.athleteData?.firstName || ""} ${
                  athleteData?.athleteData?.lastName || ""
                }`
              : ""
          }
          navigationLink="/schoolathletes"
          iconList={
            adminRole === "SCHOOL ADMIN" ||
            assignedRights.includes("Add / Remove Athletes")
              ? headerIcons
              : []
          }
        />

        <div>
          <div className="d-flex-space-between pd-20 flex-wrap light-grey-border">
            <div className="d-flex-align-cent gap-20">
              <Badge
                overlap="circular"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                badgeContent={
                  <span className="jerseyNumber-badge">
                    {athleteData?.athleteData?.jerseyNumber}
                  </span>
                }
              >
                <Avatar
                  alt="Travis Howard"
                  src={
                    athleteData?.athleteLogo
                      ? athleteData?.athleteLogo
                      : blankProfile
                  }
                  className="avatar-image"
                />
              </Badge>
              <div>
                <h4 className="fs-30 bold athlete-nm">
                  {athleteData?.athleteData?.firstName}{" "}
                  {athleteData?.athleteData?.lastName}
                </h4>
                <h6 className="mt-1 semi-bold fs-18">
                  {athleteData?.athleteData?.positionPlayed}
                </h6>
              </div>
              <SchoolStatus
                status={
                  athleteData?.athleteData?.user &&
                  athleteData?.athleteData?.user.active
                }
                isDeleted={
                  athleteData?.athleteData?.user &&
                  athleteData?.athleteData?.user.deleted
                }
              />
            </div>
          </div>
          <div className="row px-2">
            <div className="col-12 col-lg-6 col-md-12  w-100 plr pt-1 ">
              <div className="clear10"></div>
              <div className="row p-1 ">
                <label className="fs-20 bold">Personal Information</label>
              </div>
              <div>
                <div className="col-12 col-lg-12 col-md-10  w-100 plr pt-1  team-details fs-18">
                  <div className="clear10 col-md-12"></div>
                  <div className="row p-1">
                    <div className="col-12 col-lg-4 col-md-4 fmlabel">
                      <label>Date Joined</label>
                    </div>
                    <div className="col-12 col-lg-8 col-md-8">
                      <p>
                        {moment(athleteData?.athleteData?.createdAt).format(
                          "MM/DD/YYYY"
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-12 col-lg-4 col-md-4 fmlabel">
                      <label>Email</label>
                    </div>
                    <div className="col-12 col-lg-8 col-md-8">
                      <p>{athleteData?.athleteData?.email}</p>
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-12 col-lg-4 col-md-4 fmlabel">
                      <label>Contact</label>
                    </div>
                    <div className="col-12 col-lg-8 col-md-8">
                      <p>
                        {formatPhoneNumber(
                          athleteData?.athleteData?.phoneNumber
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-12 col-lg-4 col-md-4 fmlabel">
                      <label>Graduation Year</label>
                    </div>
                    <div className="col-12 col-lg-8 col-md-8">
                      <p>{athleteData?.athleteData?.graduationYear}</p>
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-12 col-lg-4 col-md-4 fmlabel">
                      <label>Position Played</label>
                    </div>
                    <div className="col-12 col-lg-8 col-md-8">
                      <p>{athleteData?.athleteData?.positionPlayed}</p>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-lg-12 col-md-10  w-100 plr pt-1 mt-3 team-details fs-18">
                  <div className="clear10 col-md-12"></div>
                  <div className="row p-1">
                    <div className="col-12 col-lg-4 col-md-4 fmlabel">
                      <label>Group</label>
                    </div>
                    <div className="col-12 col-lg-8 col-md-8">
                      <div className="d-flex flex-direction-c gap-7">
                        {athleteData?.athleteData?.groupAthletes &&
                          athleteData?.athleteData?.groupAthletes.map(
                            (data, index) => (
                              <p className="fs-18 semi-bold" key={index}>
                                {data.name}
                              </p>
                            )
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="clear10"></div>
                </div>
                <div className="col-12 col-lg-12 col-md-10  w-100 plr pt-1 mt-3 team-details fs-18">
                  <div className="clear10 col-md-12"></div>

                  <div className="row p-1">
                    <div className="col-12 col-lg-4 col-md-4 fmlabel">
                      <label>Instagram</label>
                    </div>
                    <div className="col-12 col-lg-8 col-md-8">
                      <p>
                        {athleteData?.athleteData?.instagramLink
                          ? athleteData?.athleteData?.instagramLink
                          : "--"}
                      </p>
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-12 col-lg-4 col-md-4 fmlabel">
                      <label>Twitter</label>
                    </div>
                    <div className="col-12 col-lg-8 col-md-8">
                      <p>
                        {athleteData?.athleteData?.twitterLink
                          ? athleteData?.athleteData?.twitterLink
                          : "--"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="clear20"></div>
          </div>
        </div>
        <Popover
          id={id}
          open={open || false}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <SettingsPopup settingList={settingList()} />
        </Popover>
      </div>
    </div>
  );
}

export default AtheletDetails;
